import React from 'react';
import { PropTypes } from 'prop-types';
import InputMask from 'react-input-mask';

export const defaultMaskConfig = {
  acceptedCharacters: {
    '*': '[A-Za-z0-9]',
    9: '[0-9]',
    a: '[A-Za-z]',
  },
  containsInvalidatedCharacters: _ => false
};
export const numericAsterixMaskConfig = {
  acceptedCharacters: { ...defaultMaskConfig.acceptedCharacters, '*': '[0-9]' },
  containsInvalidatedCharacters: value => /[A-Za-z]/.test(value)
};

const StrictInput = ({
  input,
  mask,
  maskChar,
  maskConfigAfterValueChange,
  className,
  placeholder,
  style
}) => {
  const maskConfig = { ...defaultMaskConfig };

  const beforeMaskedValueChange = (newState, oldState, userInput) => {
    if (!maskConfigAfterValueChange) {
      return newState;
    }
    if (!oldState.selection) {
      oldState.selection = { start: null, end: null };
    }

    const re = new RegExp(maskChar, 'g');
    const newValue = newState.value.replace(re, '');
    const oldValue = oldState.value.replace(re, '');
    const hasValueChanged = userInput || (newValue !== oldValue);
    if (!hasValueChanged) {
      return newState;
    }

    maskConfig.acceptedCharacters = maskConfigAfterValueChange.acceptedCharacters;
    maskConfig.containsInvalidatedCharacters = maskConfigAfterValueChange.containsInvalidatedCharacters;
    const oldValueValid = !maskConfig.containsInvalidatedCharacters(oldValue);
    const newValueValid = !maskConfig.containsInvalidatedCharacters(newValue);
    if (oldValueValid && !newValueValid) {
      return oldState;
    }

    if (newValueValid) {
      return newState;
    }

    userInput ??= '';
    const newInput = maskConfig.containsInvalidatedCharacters(userInput) ? '' : userInput;
    return { value: newInput, selection: { start: newInput.length, end: newInput.length } };
  };

  return (
    <InputMask
      { ...input }
      mask={ mask }
      maskChar={ maskChar }
      className={ `${ className }` }
      placeholder={ `${ placeholder }` }
      style={ style }
      beforeMaskedValueChange={ beforeMaskedValueChange }
      formatChars={ maskConfig.acceptedCharacters }
      alwaysShowMask
    />
  );
};

StrictInput.propTypes = {
  input: PropTypes.shape({ value: PropTypes.string }).isRequired,
  mask: PropTypes.string.isRequired,
  maskChar: PropTypes.string.isRequired,
  maskConfigAfterValueChange: PropTypes.shape({
    acceptedCharacters: PropTypes.objectOf(PropTypes.string),
    containsInvalidatedCharacters: PropTypes.func,
  }).isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  style: PropTypes.shape({})
};

StrictInput.defaultProps = {
  className: '',
  placeholder: '',
  style: null
};

// eslint-disable-next-line import/prefer-default-export
export { StrictInput };
